import { makeStyles, Tooltip } from '@material-ui/core'
import { Close, LooksOne, LooksTwo } from '@material-ui/icons'
import { Badge, DisabledByDefault, VerticalShades } from '@mui/icons-material'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useRefresh,
  useTranslate,
} from 'react-admin'
import { SetWorkingModeDialog } from '../DoorDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { ResourceName } from '../../../../core/ResourceName'
import { DoorWorkingModes } from '../../../../core/enum/DoorWorkingModes'
import { Authority } from '../../../../core/auth/Authority'
import { DoorWorkingModeById } from '../../../../core/devices/doors/doors.utils'

const useStyles = makeStyles(() => ({
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
}))

export const DoorSetWorkingModeCompactButton = ({ ...props }) => {
  const { jsonStatus, record, asRecurringJob } = props
  const translate = useTranslate()
  const classes = useStyles()
  const [mutate, { loading }] = useMutation()
  const hasAuthority = useHasAuthority()
  const refresh = useRefresh()

  const [workingModeDialogOpen, setWorkingModeDialogOpen] = useState(false)
  const [workingMode, setWorkingMode] = useState<DoorWorkingModes | undefined>(
    DoorWorkingModeById[jsonStatus?.workingMode],
  )

  const handleOpenDialog = () => {
    setWorkingModeDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setWorkingModeDialogOpen(false)
  }

  const handleWorkingMode = () => {
    mutate({
      type: sanitizeFetchType('setDoorWorkingMode'),
      resource: ResourceName.DOORS,
      payload: {
        doorId: record?.id,
        workingMode,
      },
    })
    handleCloseDialog()
    refresh()
  }

  return (
    <div>
      <SetWorkingModeDialog
        open={workingModeDialogOpen}
        close={() => setWorkingModeDialogOpen(false)}
        workingMode={workingMode}
        setWorkingMode={setWorkingMode}
        handleSetWorkingMode={handleWorkingMode}
        asRecurringJob={asRecurringJob}
        door={record}
      />
      <Tooltip
        title={
          jsonStatus?.workingMode !== undefined
            ? translate(
                `resources.enums.DoorWorkingModes.${
                  DoorWorkingModeById[jsonStatus?.workingMode]
                }`,
              )
            : translate('resources.enums.WorkingMode.null')
        }
        onClick={
          !loading && hasAuthority(Authority.DOORS_SET_WORKING_MODE)
            ? handleOpenDialog
            : undefined
        }
      >
        <div
          className={classes.iconContainer}
          style={{
            cursor:
              !loading && hasAuthority(Authority.DOORS_SET_WORKING_MODE)
                ? 'pointer'
                : 'default',
          }}
        >
          {DoorWorkingModeById[jsonStatus?.workingMode] ===
            DoorWorkingModes.DoorReleased && (
            <VerticalShades className={classes.icon} />
          )}
          {DoorWorkingModeById[jsonStatus?.workingMode] ===
            DoorWorkingModes.CardVerification && (
            <Badge className={classes.icon} />
          )}
          {DoorWorkingModeById[jsonStatus?.workingMode] ===
            DoorWorkingModes.FirstReaderDisabled && (
            <LooksOne className={classes.icon} />
          )}
          {DoorWorkingModeById[jsonStatus?.workingMode] ===
            DoorWorkingModes.SecondReaderDisabled && (
            <LooksTwo className={classes.icon} />
          )}
          {DoorWorkingModeById[jsonStatus?.workingMode] ===
            DoorWorkingModes.AllReadersDisabled && (
            <DisabledByDefault className={classes.icon} />
          )}
          {(jsonStatus?.workingMode === undefined ||
            jsonStatus?.workingMode === null) && (
            <>
              <VerticalShades className={classes.icon} />
              <Close fontSize="large" className={classes.crossIcon} />
            </>
          )}
        </div>
      </Tooltip>
    </div>
  )
}
